export default __webpack_public_path__ + "239d6e0af8aeabdec3863da1a917c6e3.png";